import { render } from "./joinOurTeam.vue?vue&type=template&id=dc21c9f4&ts=true"
import script from "./joinOurTeam.vue?vue&type=script&lang=ts"
export * from "./joinOurTeam.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__